// Persian/Jalali formatting helpers. No React, no state — pure functions.
export function formatCountdownPersian(seconds, isoDate) {
  if (seconds <= 0) return "اکنون";
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // For far-off stories, give a coarse label + the exact Jalali date
  if (days > 7) {
    let label;
    if (days > 30) label = "بیش از یک ماه دیگر";
    else if (days > 14) label = "بیش از دو هفته دیگر";
    else label = "بیش از یک هفته دیگر";
    const exact = isoDate ? jalaliDateLabel(isoDate) : "";
    return exact ? `${label} — ${exact}` : label;
  }

  if (days >= 2) return `${toPersianDigits(days)} روز دیگر`;
  if (days >= 1) return `۱ روز و ${toPersianDigits(hours)} ساعت دیگر`;
  if (hours >= 1) return `${toPersianDigits(hours)} ساعت و ${toPersianDigits(minutes)} دقیقه دیگر`;
  return `${toPersianDigits(minutes)} دقیقه دیگر`;
}

// "۲۹ مرداد ۱۴۰۵" from an ISO datetime string
export function jalaliDateLabel(isoDate) {
  try {
    const d = new Date(isoDate);
    const j = greToJalaliFull(d.getFullYear(), d.getMonth() + 1, d.getDate());
    return `${toPersianDigits(j.jd)} ${JALALI_MONTHS[j.jm - 1]} ${toPersianDigits(j.jy)}`;
  } catch { return ""; }
}

export function toPersianDigits(n) {
  return String(n).replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
}
// v3 fears (services/questionnaire_v3.py FEARS) + v2's two lumped ones.
export const FEAR_NAMES = {
  q55: "تاریکی", fear_alone: "تنها خوابیدن", fear_monster: "هیولا و موجودات خیالی", fear_jinn: "جن و روح",
  fear_dogcat: "سگ یا گربه", fear_insect: "حشرات", q56: "صداهای بلند", fear_water: "آب و حمام",
  fear_height: "ارتفاع", fear_doctor: "دکتر و آمپول", q57: "غریبه‌ها", fear_lost: "گم شدن",
  q58: "اضطراب جدایی", fear_parent_loss: "مریض شدن یا از دست دادن والدین", q59: "آسیب جسمانی",
  fear_war: "جنگ و صدای انفجار", fear_quake: "زلزله",
  q56_v2: "حیوانات یا صداهای بلند", q57_v2: "غریبه‌ها یا موقعیت‌های جدید",
};

export const fmt = n => n.toLocaleString("fa-IR");


// ── Shared UI atoms ───────────────────────────────────────────────────────────
// ISO timestamp → Jalali date string. Persian digits come free from the locale.
export function faDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? "—" : d.toLocaleDateString("fa-IR");
}


export const JALALI_MONTHS = ["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"];

export function greToJalali(gy, gm) {
  const gd = 15;
  const g_d_m = [0,31,59,90,120,151,181,212,243,273,304,334];
  let gy2 = (gm > 2) ? (gy + 1) : gy;
  let days = 355666 + (365 * gy) + Math.floor((gy2 + 3) / 4) - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
  let jy = -1595 + (33 * Math.floor(days / 12053));
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) { jy += Math.floor((days - 1) / 365); days = (days - 1) % 365; }
  let jm = (days < 186) ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
  return { jy, jm };
}

// Tiny badge showing which models made a story (hover for full ids).

export const faUsd = (n) => toPersianDigits(Number(n).toFixed(n < 1 ? 3 : n < 100 ? 2 : 1)).replace(".", "٫");

// Top up / correct the API credit. Spend is always DERIVED from recorded usage, so
// both actions just move the BUDGET: «افزودن شارژ» adds to it, «تصحیح باقی‌مانده»
// sets it to (your figure + spend) so the remaining lands exactly where you say.

export const JALALI_WEEKDAYS = ["شنبه", "یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه"];

export function greToJalaliFull(gy, gm, gd) {
  const g_d_m = [0,31,59,90,120,151,181,212,243,273,304,334];
  let gy2 = (gm > 2) ? (gy + 1) : gy;
  let days = 355666 + (365 * gy) + Math.floor((gy2 + 3) / 4) - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
  let jy = -1595 + (33 * Math.floor(days / 12053));
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) { jy += Math.floor((days - 1) / 365); days = (days - 1) % 365; }
  let jm, jd;
  if (days < 186) { jm = 1 + Math.floor(days / 31); jd = 1 + (days % 31); }
  else { jm = 7 + Math.floor((days - 186) / 30); jd = 1 + ((days - 186) % 30); }
  return { jy, jm, jd };
}

export function jalaliToWeekday(jy, jm, jd) {
  // Convert Jalali to Gregorian to get weekday
  // Inverse of greToJalaliFull — approximate via Date
  // Use a reference: 1 Farvardin 1400 = 21 March 2021 (Sunday = weekday 0)
  // Days in Jalali months: 31*6, 30*5, 29 or 30
  const jMonthDays = [31,31,31,31,31,31,30,30,30,30,30,29];
  let totalDays = 0;
  for (let y = 1400; y < jy; y++) {
    const isLeap = [1,5,9,13,17,22,26,30].includes(y % 33);
    totalDays += isLeap ? 366 : 365;
  }
  for (let m = 1; m < jm; m++) totalDays += jMonthDays[m - 1];
  totalDays += jd - 1;
  // Reference date: 1 Farvardin 1400 = 2021-03-21 (Sunday)
  const refDate = new Date(2021, 2, 21); // March 21, 2021
  refDate.setDate(refDate.getDate() + totalDays);
  // JS: 0=Sun, 6=Sat. Jalali week: Sat=0, Sun=1, ..., Fri=6
  const jsDay = refDate.getDay();
  return jsDay === 6 ? 0 : jsDay + 1; // Convert: Sat(6)->0, Sun(0)->1, Mon(1)->2, ...
}

export function jalaliMonthDays(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  const isLeap = [1,5,9,13,17,22,26,30].includes(jy % 33);
  return isLeap ? 30 : 29;
}

export function formatRemaining(seconds) {
  if (seconds <= 0) return "اکنون";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 24) return `${toPersianDigits(Math.floor(h / 24))} روز دیگر`;
  if (h > 0) return `${toPersianDigits(h)} ساعت دیگر`;
  return `${toPersianDigits(m)} دقیقه دیگر`;
}



// ── Family (parent) ordering — «کودکان و اشتراک‌ها» and «پرسشنامه‌ها» ─────────
// "id" is the order the server has always returned: by user id, i.e. the order
// parents FIRST opened the app (pre-created rows keep the id they were made with).
export const FAMILY_SORTS = [
  { key: "id",     label: "پیش‌فرض (شناسهٔ کاربر)" },
  { key: "name",   label: "نام والد" },
  { key: "signup", label: "تاریخ عضویت" },
];
export const FAMILY_SORT_DEFAULT = { key: "id", dir: "asc" };
export const FAMILY_SORT_DIRS = { id: "asc", name: "asc", signup: "desc" };

/** families: [{ parentId, name, createdAt }] → a new, sorted array. */
export function sortFamilies(families, { key, dir }) {
  const sign = dir === "desc" ? -1 : 1;
  const cmp = {
    id:     (a, b) => a.parentId - b.parentId,
    name:   (a, b) => (a.name || "").localeCompare(b.name || "", "fa"),
    signup: (a, b) => (new Date(a.createdAt || 0) - new Date(b.createdAt || 0)) || (a.parentId - b.parentId),
  }[key] || ((a, b) => a.parentId - b.parentId);
  return [...families].sort((a, b) => sign * cmp(a, b));
}
